/**
 * @generated SignedSource<<2bbc851d2ec8a5b07128d935ed215b33>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type initialSurveyHomeQuery$variables = {
  refundHistoryId: string;
};
export type initialSurveyHomeQuery$data = {
  readonly getSurveyBusinessAnswer: {
    readonly businessAnswer: ReadonlyArray<{
      readonly bmanTin: string | null | undefined;
      readonly isCompleted: boolean | null | undefined;
    }> | null | undefined;
  };
  readonly getSurveyBusinessInfo: {
    readonly business: ReadonlyArray<{
      readonly bmanTin: string | null | undefined;
      readonly bsno: string | null | undefined;
      readonly tfbDtcsNm: string | null | undefined;
      readonly tnm: string | null | undefined;
      readonly totalAmount: number | null | undefined;
    }> | null | undefined;
    readonly result: boolean;
  };
  readonly getSurveyStatus: {
    readonly surveyStatus: {
      readonly totalAmount: number | null | undefined;
    } | null | undefined;
  };
};
export type initialSurveyHomeQuery = {
  response: initialSurveyHomeQuery$data;
  variables: initialSurveyHomeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "refundHistoryId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "refundHistoryId",
    "variableName": "refundHistoryId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalAmount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bmanTin",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": (v1/*: any*/),
    "concreteType": "SurveyStatusOutput",
    "kind": "LinkedField",
    "name": "getSurveyStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SurveyStatus",
        "kind": "LinkedField",
        "name": "surveyStatus",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": (v1/*: any*/),
    "concreteType": "SurveyBusinessInfoOutput",
    "kind": "LinkedField",
    "name": "getSurveyBusinessInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SurveyBusinessInfo",
        "kind": "LinkedField",
        "name": "business",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tfbDtcsNm",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tnm",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bsno",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": (v1/*: any*/),
    "concreteType": "SurveyBusinessAnswerOutput",
    "kind": "LinkedField",
    "name": "getSurveyBusinessAnswer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SurveyBusinessAnswer",
        "kind": "LinkedField",
        "name": "businessAnswer",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isCompleted",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "initialSurveyHomeQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "initialSurveyHomeQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "a3752e5bff0e1975d900ab0e33100e56",
    "id": null,
    "metadata": {},
    "name": "initialSurveyHomeQuery",
    "operationKind": "query",
    "text": "query initialSurveyHomeQuery(\n  $refundHistoryId: String!\n) {\n  getSurveyStatus(refundHistoryId: $refundHistoryId) {\n    surveyStatus {\n      totalAmount\n    }\n  }\n  getSurveyBusinessInfo(refundHistoryId: $refundHistoryId) {\n    result\n    business {\n      bmanTin\n      tfbDtcsNm\n      tnm\n      bsno\n      totalAmount\n    }\n  }\n  getSurveyBusinessAnswer(refundHistoryId: $refundHistoryId) {\n    businessAnswer {\n      bmanTin\n      isCompleted\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2639b58816ef3605165cae259e0b2a08";

export default node;
